

<button
  *ngIf="inIframe"
  (click)="onFinish()"
  pButton
  label="{{'payment-gate-payment-status.PAID.done-btn-label' | translate}}"
  class="p-button-sm p-button-success {{widthClass}} max-w-full">
</button>